import * as Yup from "yup";

// All fields are optional at the schema level — empty appended rows and
// rows whose selected item resolves to no SKU at the current location
// must not block consultation submit. Handle-submit and the dispense hook
// both filter out incomplete rows downstream.
export const NON_PHARMA_ITEM_SCHEMA = Yup.object({
  skuId: Yup.string().defined(),
  skuName: Yup.string().defined(),
  skuBrand: Yup.string().defined(),
  nonPharmaItemId: Yup.string().defined(),
  quantity: Yup.number().integer().min(1).defined(),
  lotId: Yup.string().nullable().defined(),
});

export const NON_PHARMA_ITEMS_SCHEMA = Yup.array().of(NON_PHARMA_ITEM_SCHEMA);
